import Vue from "vue";
// import md5 from "js-md5";
import router from "@/router";
import config from "@/config";
import errorTags from "@/errorTags";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      loginSession: false,
      logout: false,
      firstTime: false,
      securityDisable: false,
      securityValidate: false,
      securityUpdate: false,
      addSubAccount: false,
      getSubAccountDetails: false,
      addAccount: false,
      // editAccount: false,
      updatePassword: false,
      checkDirectDownline: false,
      getOverviewSummary: false,
      getAccountWinlose: false,
      getAccountOutstanding: false,
      getActiveAccount: false,
      getTop10Account: false,
      getPositionTaking: false,
      getCommission: false,
      getBetLimit: false,
      getScheduleList: false,
      getWallet: false,
      getPlatform: false,
      getCreditUsedDownline: false,
      getSubAccountList: false,
      getAccountList: false,
      getMemberList: false,
      getMemberListAlert: false,
      updateStatus: false,
      updateAuthority: false,
      subAccountBlock: false,
      subAccountUnblock: false,
      getChildCommission: false,
      getChildBetLimit: false,
      getChildPositionTaking: false,
      updateCommissionSB: false,
      updateCommissionMMO: false,
      updateCommissionSL: false,
      updateCommissionLC: false,
      updateCommissionLO: false,
      updateCommissionKN: false,
      updateCommissionCF: false,
      updateCommissionLT: false,
      updateCommissionTN: false,
      updatePositionTakingSB1: false,
      updatePositionTakingSB2: false,
      updatePositionTakingMMO: false,
      updatePositionTakingLC: false,
      updatePositionTakingSL: false,
      updatePositionTakingLO: false,
      updatePositionTakingKN: false,
      updatePositionTakingCF: false,
      updatePositionTakingLT: false,
      updateBetLimitSB: false,
      updateBetLimitLC: false,
      updateBetLimitLO: false,
      updateBetLimitKN: false,
      updateBetLimitCF: false,
      updateBetLimitLT: false,
      updateAccountDetails: false,
      getAccountDetails: false,
      getForecastLookup: false,
      getForecastList: false,
      getMatchLookup: false,
      getSettlementList: false,
      settlement: false,
      getSettlementHistory: false,
      getDailyStatement: false,
      getDailySettlement: false,
      getDailyWinlose: false,
      getPlatformWinlose: false,
      getSportTypeWinlose: false,
      getLeagueWinlose: false,
      getMatchWinlose: false,
      getMatchMemberWinlose: false,
      getBetlist: false,
      getPendingMatches: false,
      getGameResult: false,
      resetWin: false,
      getParlayDetail: false,
      getEsportsDetailCombo: false,
      getGameTypeLookup: false,
      getLeagueLookup: false,
      getMatchResult: false,
      checkDownline: false,
      getCreditUsedSummary: false,
      getSystemParlay: false,
      getSystemParlayMatch: false,
      getSystemParlayBet: false,
      getTournamentJackpot: false,
      getTournamentRefund: false
    },
    login: "",
    account: "",
    profile: "",
    access: "",
    ptList: "",
    cmList: "",
    blList: "",
    wallet: "",
    credit_used_downline: "",
    scheduleList: "",
    platform: "",
    platformLookUp: [],
    tier: [],
    selectedID: "",
    selectedType: "",
    gameTypeLookUp: [],
    leagueLookUp: [],
    alert: false,
    alertCall: 0
  },
  mutations: {
    updatePlayerAlert(state, payload) {
      state.alert = payload;
    },
    updatePlayerAlertCall(state, payload) {
      state.alertCall = payload;
    },
    updateTier(state, payload) {
      state.tier = payload;
    },
    updateSelectedID(state, payload) {
      state.selectedID = payload;
    },
    updateSelectedType(state, payload) {
      state.selectedType = payload;
    },
    updateSecurityDisabled(state, payload) {
      state.profile.security_disabled = payload.security_disabled;
    },
    updateSecurityTag(state, payload) {
      state.profile.security_tag = payload.security_tag;
    },
    updateProfile(state, payload) {
      state.profile.full_name = payload.name;
      state.profile.contact_phone = payload.phone;
      state.profile.contact_email = payload.email;
    },
    update(state, payload) {
      // console.log("update", state);
      state.login = payload.data.login[0];
      state.account = payload.data.account[0];
      state.profile = payload.data.profile[0];
      state.access = payload.data.access[0] || "";
    },
    updateLastPasswordChanges(state, payload) {
      state.profile.last_password_changed = payload.current_date;
    },
    updatePT(state, payload) {
      state.ptList = payload.data;
    },
    updateCM(state, payload) {
      state.cmList = payload.data;
    },
    updateBL(state, payload) {
      state.blList = payload.data;
    },
    updateSchedule(state, payload) {
      state.scheduleList = payload.data;
    },
    updateWallet(state, payload) {
      state.wallet = payload.data;
    },
    updatePlatform(state, payload) {
      state.platform = payload.data;
    },
    updatePlatformLookUp(state, payload) {
      state.platformLookUp = payload.data;
    },
    updateGameTypeLookUp(state, payload) {
      state.gameTypeLookUp = payload.data;
    },
    updateLeagueLookUp(state, payload) {
      state.leagueLookUp = payload.data;
    },
    updateCreditUsedDownline(state, payload) {
      state.credit_used_downline = payload.data;
    },
    delete(state) {
      // console.log("user.delete", state);
      state.login = "";
      state.account = "";
      state.profile = "";
      state.access = "";
      state.ptList = "";
      state.cmList = "";
      state.blList = "";
      state.wallet = "";
      state.credit_used_downline = "";
      state.scheduleList = "";
      state.platform = "";
      state.selectedID = "";
      state.selectedType = "";
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    }
  },
  actions: {
    setPlayerAlert(context, payload) {
      context.commit("updatePlayerAlert", payload);
    },
    setPlayerAlertCall(context, payload) {
      context.commit("updatePlayerAlertCall", payload);
    },
    setTier(context, payload) {
      context.commit("updateTier", payload);
    },
    setSelectedID(context, payload) {
      context.commit("updateSelectedID", payload);
    },
    setSelectedType(context, payload) {
      context.commit("updateSelectedType", payload);
    },
    loginSession(context, user) {
      const url = config.loginSessionUrl();
      const body = {
        auth: {
          login_id: user.login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.loginSession.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.errorTag = errorTags.loginSession.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.errorTag = errorTags.loginSession.usernameRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.loginSession == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "loginSession", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "loginSession", status: false });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.status;
                    resolve(feedback);
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.errorTag = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.errorTag = errorTags.login.systemFailed;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    login(context, user) {
      // const url = config.loginUrl();
      const url = config.secureloginUrl();
      const body = {
        auth: {
          login_id: user.login_id,
          password: user.password
        }
      };
      const feedback = {
        data: [],
        redirect: "",
        success: false,
        errorTag: errorTags.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.errorTag = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.errorTag = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.errorTag = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          var data = body;
          data = jwt.sign(body, config.tXTEV7yH);

          Vue.http.post(url, data).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var authToken = null;
                  var profileStatus = null;
                  var securityDisabled = true;
                  var data = null;
                  var status = null;

                  try {
                    status = successResponse.body.data.status;
                    if(status) {
                      feedback.data = successResponse.body.data.status;
                      feedback.redirect = "loginSession";
                      resolve(feedback);
                    } else {
                      authToken = successResponse.body.data.login[0].auth_token;
                      if (authToken) {
                        data = successResponse.body.data;
                        profileStatus = successResponse.body.data.profile[0].status;
                        switch (profileStatus) {
                          case "NEW":
                            let role = successResponse.body.data.login[0].authority_role;
                            if (role == "SUB_PRI") {
                              feedback.redirect = "/resetPassword";
                            } else {
                              feedback.redirect = "/firstTime";
                            }
                            break;
                          case "RESET":
                            securityDisabled = successResponse.body.data.profile[0].security_disabled == 0;
                            if (securityDisabled) {
                              feedback.redirect = "/security";
                            } else {
                              feedback.redirect = "/resetPassword";
                            }
                            break;
                          case "ACTIVE":
                            securityDisabled = successResponse.body.data.profile[0].security_disabled == 0;
                            if (securityDisabled) {
                              feedback.redirect = "/security";
                            } else {
                              feedback.redirect = "/overview";
                            }
                            break;
                        }

                        feedback.data = data;
                        context.commit("update", { data });
                        resolve(feedback);
                      } else {
                        context.commit("delete");
                        feedback.success = false;
                        feedback.errorTag = errorTags.login.failed;
                        reject(feedback);
                      }
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.errorTag = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.errorTag = errorTags.login.systemFailed;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    firstTime(context, user) {
      const url = config.secAccountFullUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          login_id: this.state.user.login.login_id,
          new_login_id: user.new_login_id,
          new_password: user.new_password,
          security_tag: user.security_tag,
          security_code: user.security_code,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.firstTime.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("new_login_id" in user)) {
          feedback.errorTag = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_tag" in user)) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_login_id.length <= 0) {
          feedback.errorTag = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_tag.length <= 0) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.firstTime == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "firstTime", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.errorTag = errorTags.firstTime.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              context.commit("delete");
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    securityDisable(context) {
      const url = config.securityDisableUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          profile_id: this.state.user.profile.profile_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.securityDisable == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "securityDisable",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "securityDisable",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    let security_disabled = 1;
                    let security_tag = "";
                    context.commit("updateSecurityTag", { security_tag });
                    context.commit("updateSecurityDisabled", { security_disabled });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "securityDisable",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    securityValidate(context, user) {
      const url = config.securityValidateUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          profile_id: this.state.user.profile.profile_id,
          security_code: user.security_code
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.securityValidate == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "securityValidate",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "securityValidate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "securityValidate",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    securityUpdate(context, user) {
      const url = config.securityUpdateUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          profile_id: this.state.user.profile.profile_id,
          security_tag: user.security_tag,
          security_code: user.security_code
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("security_tag" in user)) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.security_tag.length <= 0) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.securityUpdate == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "securityUpdate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "securityUpdate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    var security_tag = body.data.security_tag;
                    var security_disabled = 0;
                    context.commit("updateSecurityDisabled", { security_disabled });
                    context.commit("updateSecurityTag", { security_tag });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "securityUpdate",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addSubAccount(context, user) {
      const url = config.addSubAccountUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          new_login_id: user.new_login_id,
          new_password: user.new_password,
          authority_option: user.authority_option,
          full_name: user.full_name,
          contact_phone: user.contact_phone,
          contact_email: user.contact_email,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.addAccount.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("new_login_id" in user)) {
          feedback.errorTag = errorTags.addAccount.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.addAccount.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_login_id.length <= 0) {
          feedback.errorTag = errorTags.addAccount.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.addAccount.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addSubAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addSubAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addSubAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSubAccountDetails(context, user) {
      const url = config.getSubAccountDetailsUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: this.state.user.account.account_id,
          sub_login_id: user.sub_login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("sub_login_id" in user)) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.sub_login_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountDetails == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSubAccountDetails",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubAccountDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountDetails.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubAccountDetails",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSubAccountList(context, user) {
      const url = config.getSubAccountListUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSubAccountList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSubAccountList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubAccountList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.subAccountList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubAccountList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addAccount(context, user) {
      const url = ['MMK','MMO'].includes(user.currency) ? config.addAccountMmoUrl() : config.addAccountUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account: {
            account_type: this.state.user.account.account_type,
            account_id: user.account_id,
            parent_id: this.state.user.account.account_id,
            password: user.password,
            full_name: user.full_name,
            contact_phone: user.contact_phone,
            contact_email: user.contact_email,
            audit_by: this.state.user.login.login_id,
            remark: "add new account",
            schedule_1: user.payment.schedule_1,
            schedule_2: user.payment.schedule_2,
            schedule_3: user.payment.schedule_3,
            schedule_4: user.payment.schedule_4,
            schedule_5: user.payment.schedule_5,
            schedule_6: user.payment.schedule_6,
            schedule_7: user.payment.schedule_7,
            credit_limit: user.credit_limit,
            member_credit_limit: user.member_credit_limit,
            win_limit_multiplier: user.win_limit_multiplier,
            daily_reset: user.daily_reset
          },
          pt: user.pt,
          cm: user.cm,
          bl: user.bl
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.addAccount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.addAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addAccount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.addAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    // editAccount(context, user) {
    //   const url = config.editAccountUrl();
    //   const body = {
    //     auth: {
    //       login_id: this.state.user.login.login_id,
    //       account_id: this.state.user.account.account_id,
    //       profile_id: this.state.user.profile.profile_id,
    //       auth_token: this.state.user.login.auth_token
    //     },
    //     data: {
    //       full_name: user.full_name,
    //       contact_phone: user.contact_phone,
    //       contact_email: user.contact_email
    //     }
    //   };
    //   const feedback = {
    //     success: false,
    //     errorTag: errorTags.editAccount.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (this.state.user._loading.editAccount == true) {
    //       feedback.errorTag = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", { action: "editAccount", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "editAccount",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.success == "string") {
    //               feedback.success = successResponse.body.success == "1";
    //             } else {
    //               feedback.success = successResponse.body.success == true;
    //             }
    //             feedback.errorTag = successResponse.body.errorTag;
    //             if (feedback.success == true) {
    //               try {
    //                 var name = body.data.full_name;
    //                 var phone = body.data.contact_phone;
    //                 var email = body.data.contact_email;
    //                 context.commit("updateProfile", { name, phone, email });
    //                 resolve(feedback);
    //               } catch (error) {
    //                 feedback.success = false;
    //                 feedback.errorTag = errorTags.editAccount.failed;
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.errorTag == errorTags.session.expired ||
    //                 feedback.errorTag == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/expired");
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "editAccount",
    //             status: false
    //           });
    //           feedback.errorTag = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    getAccountList(context, user) {
      const url = config.getAccountListUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          target_account_id: user.target_account_id,
          status: user.status,
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        line: [],
        data: [],
        success: false,
        errorTag: errorTags.getAccountList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getAccountList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.line = successResponse.body.data.accountLine;
                    feedback.data = successResponse.body.data.accountList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberList(context, user) {
      const url = config.getMemberListUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          target_account_id: user.target_account_id,
          status: user.status,
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        line: [],
        data: [],
        success: false,
        errorTag: errorTags.getMemberList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getMemberList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getMemberList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMemberList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.line = successResponse.body.data.accountLine;
                    feedback.data = successResponse.body.data.accountList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getMemberList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMemberList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberListAlert(context, user) {
      const url = config.getMemberListAlertUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getMemberListAlert.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getMemberListAlert.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getMemberListAlert.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberListAlert == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberListAlert", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMemberListAlert",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.accountList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getMemberListAlert.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMemberListAlert",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateAccountDetails(context, user) {
      const url = config.updateAccountDetailsUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          full_name: user.full_name,
          contact_phone: user.contact_phone,
          contact_email: user.contact_email,
          credit_limit: user.credit_limit,
          member_credit_limit: user.member_credit_limit,
          schedule_1: user.payment.schedule_1,
          schedule_2: user.payment.schedule_2,
          schedule_3: user.payment.schedule_3,
          schedule_4: user.payment.schedule_4,
          schedule_5: user.payment.schedule_5,
          schedule_6: user.payment.schedule_6,
          schedule_7: user.payment.schedule_7,
          audit_by: this.state.user.login.login_id,
          win_limit_multiplier: user.win_limit_multiplier,
          daily_reset: user.daily_reset
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.updateAccountDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateAccountDetails == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateAccountDetails",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateAccountDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateAccountDetails.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateAccountDetails",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAccountDetails(context, user) {
      const url = config.getAccountDetailsUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: this.state.user.account.account_id,
          target_account_id: user.account_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountDetails.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountDetails == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getAccountDetails",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountDetails.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountDetails",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.updatePasswordUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          password: user.password,
          new_password: user.new_password
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("password" in user)) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateStatus(context, user) {
      const url = config.updateStatusUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          status: user.status
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateStatus.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("status" in user)) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.status.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateStatus == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updateStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateStatus.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    unblockProfile(context, user) {
      const url = config.unblockProfileUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          profile_id: user.profile_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.unblockProfile.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("profile_id" in user)) {
          feedback.errorTag = errorTags.unblockProfile.profileIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.profile_id.length <= 0) {
          feedback.errorTag = errorTags.unblockProfile.profileIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.unblockProfile == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "unblockProfile", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "unblockProfile",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.unblockProfile.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "unblockProfile",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateAuthority(context, user) {
      const url = config.updateAuthorityUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          login_id: user.login_id,
          authority_option: user.authority_option
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateAuthority.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.errorTag = errorTags.updateAuthority.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.login_id.length <= 0) {
          feedback.errorTag = errorTags.updateAuthority.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateAuthority == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateAuthority",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateAuthority",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateAuthority.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateAuthority",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPassword(context, user) {
      const url = config.resetPasswordUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          target_login_id: user.target_login_id,
          new_password: user.new_password
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetPassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("target_login_id" in user)) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.target_login_id.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetPassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetPassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPasswordSub(context, user) {
      const url = config.resetPasswordSubUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          target_login_id: user.target_login_id,
          new_password: user.new_password
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetPassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("target_login_id" in user)) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.target_login_id.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.targetIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.resetPassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetPassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetPassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "resetPassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetPasswordPost(context, user) {
      const url = config.resetPasswordPostUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          password: user.password,
          new_password: user.new_password,
          security_tag: user.security_tag,
          security_code: user.security_code
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("password" in user)) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_tag" in user)) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.errorTag = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_tag.length <= 0) {
          feedback.errorTag = errorTags.security.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.errorTag = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    let security_disabled = 0;
                    let security_tag = body.data.security_tag;
                    context.commit("updateSecurityTag", { security_tag });
                    context.commit("updateSecurityDisabled", { security_disabled });
                    let current_date = moment().format("YYYY-MM-DDTHH:mm:ss");
                    context.commit("updateLastPasswordChanges", { current_date });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    subAccountBlock(context, user) {
      const url = config.subAccountBlockUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          sub_login_id: user.sub_login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.subAccountBlock.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("sub_login_id" in user)) {
          feedback.errorTag = errorTags.subAccountBlock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.sub_login_id.length <= 0) {
          feedback.errorTag = errorTags.subAccountBlock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.subAccountBlock == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "subAccountBlock",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "subAccountBlock",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.subAccountBlock.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "subAccountBlock",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    subAccountUnblock(context, user) {
      const url = config.subAccountUnblockUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          sub_login_id: user.sub_login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.subAccountUnblock.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("sub_login_id" in user)) {
          feedback.errorTag = errorTags.subAccountUnblock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.sub_login_id.length <= 0) {
          feedback.errorTag = errorTags.subAccountUnblock.loginIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.subAccountUnblock == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "subAccountUnblock",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "subAccountUnblock",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.subAccountUnblock.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "subAccountUnblock",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkDirectDownline(context, user) {
      const url = config.checkDirectDownlineUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.checkDirectDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.checkDirectDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDirectDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.checkDirectDownline == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "checkDirectDownline",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDirectDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.checkDirectDownline.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDirectDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getOverviewSummary(context, user) {
      const url = config.getOverviewSummaryUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getOverviewSummary.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getOverviewSummary.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getOverviewSummary.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getOverviewSummary == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getOverviewSummary",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getOverviewSummary",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getOverviewSummary.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getOverviewSummary",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAccountWinlose(context, user) {
      const url = config.getAccountWinloseUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountWinlose.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getAccountWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getAccountWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAccountOutstanding(context, user) {
      const url = config.getAccountOutstandingUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getAccountOutstanding.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getAccountOutstanding.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getAccountOutstanding.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getAccountOutstanding == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getAccountOutstanding",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAccountOutstanding",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getAccountOutstanding.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAccountOutstanding",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveAccount(context, user) {
      const url = config.getActiveAccountUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getActiveAccount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getActiveAccount.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getActiveAccount.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getActiveAccount == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getActiveAccount",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getActiveAccount",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getActiveAccount.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getActiveAccount",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTop10Account(context, user) {
      const url = config.getTop10AccountUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        topwinner: [],
        turnover: [],
        toploser: [],
        success: false,
        errorTag: errorTags.getTop10Account.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getTop10Account.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getTop10Account.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getTop10Account == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getTop10Account",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getTop10Account",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.topwinner = successResponse.body.data.topwinner;
                    feedback.turnover = successResponse.body.data.turnover;
                    feedback.toploser = successResponse.body.data.toploser;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getTop10Account.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getTop10Account",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPositionTaking(context, user) {
      const url = config.getPositionTakingUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code || null
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPositionTaking.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPositionTaking == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPositionTaking",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPositionTaking",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    context.commit("updatePT", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPositionTaking.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPositionTaking",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCommission(context, user) {
      const url = config.getCommissionUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code || null
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCommission.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getCommission.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getCommission.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getCommission == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getCommission", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCommission",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    context.commit("updateCM", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCommission.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCommission",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetLimit(context, user) {
      const url = config.getBetLimitUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code || null
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetLimit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetLimit == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetLimit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetLimit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    context.commit("updateBL", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetLimit.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetLimit",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSchedule(context) {
      const url = config.getScheduleUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSchedule.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSchedule.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSchedule.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSchedule == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getSchedule", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSchedule",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    context.commit("updateSchedule", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSchedule.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSchedule",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getWallet(context) {
      const url = config.getWalletUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_type: this.state.user.account.account_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getWallet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getWallet.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("account_type" in body.data)) {
          feedback.errorTag = errorTags.getWallet.accountTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getWallet.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_type.length <= 0) {
          feedback.errorTag = errorTags.getWallet.accountTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getWallet == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getWallet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getWallet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    context.commit("updateWallet", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getWallet.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getWallet", status: false });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatform(context, user) {
      const url = config.getPlatformUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPlatform.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.getPlatform.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPlatform.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPlatform == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getPlatform", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    if(body.data.account_id == body.auth.account_id) {
                      context.commit("updatePlatform", { data });
                    }
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatform.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformLookUp(context, user) {
      const url = config.getPlatformLookUpUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPlatform.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getPlatform == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getPlatform", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data.platform;
                    feedback.data = data;
                    context.commit("updatePlatformLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatform.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatform",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePlatform(context, user) {
      const url = config.updatePlatformUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code,
          platform_name: user.platform_name,
          status: user.status
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateStatus.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("platform_code" in user)) {
          feedback.errorTag = errorTags.updateStatus.platformCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("platform_name" in user)) {
          feedback.errorTag = errorTags.updateStatus.platformNameRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("status" in user)) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.platform_code.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.platformCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.platform_name.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.platformNameRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.status.length <= 0) {
          feedback.errorTag = errorTags.updateStatus.statusRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateStatus == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updateStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateStatus.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateStatus",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    resetWin(context, user) {
      const url = config.resetWinUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          member_id: user.member_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.resetWin.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("member_id" in user)) {
          feedback.errorTag = errorTags.resetWin.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.errorTag = errorTags.resetWin.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.resetWin == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "resetWin", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "resetWin", status: false });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.resetWin.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "resetWin", status: false });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCreditUsedDownline(context, user) {
      const url = config.getCreditUsedDownlineUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          account_type: user.account_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCreditUsedDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.getCreditUsedDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("account_type" in body.data)) {
          feedback.errorTag =
            errorTags.getCreditUsedDownline.accountTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.getCreditUsedDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_type.length <= 0) {
          feedback.errorTag =
            errorTags.getCreditUsedDownline.accountTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getCreditUsedDownline == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getCreditUsedDownline",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCreditUsedDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data.downline[0].used_credit;
                    feedback.data = data;
                    context.commit("updateCreditUsedDownline", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCreditUsedDownline.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCreditUsedDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getChildCommission(context, user) {
      const url = config.getCommissionUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code || null
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCommission.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getCommission.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getCommission.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getChildCommission == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getChildCommission",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getChildCommission",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCommission.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getChildCommission",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getChildBetLimit(context, user) {
      const url = config.getBetLimitUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code || null
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetLimit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetLimit.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getChildBetLimit == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getChildBetLimit",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getChildBetLimit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetLimit.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getChildBetLimit",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getChildPositionTaking(context, user) {
      const url = config.getPositionTakingUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          platform_code: user.platform_code || null
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPositionTaking.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPositionTaking.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getChildPositionTaking == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getChildPositionTaking",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getChildPositionTaking",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPositionTaking.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getChildPositionTaking",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionSB(context, user) {
      const url = config.updateCommissionSBUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          cm: user.cm,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionSB.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionSB.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionSB.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionSB == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionSB",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionSB",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionSB.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionSB",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionMMO(context, user) {
      const url = config.updateCommissionMMOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          cm: user.cm,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionMMO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionMMO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionMMO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionMMO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionMMO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionMMO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionMMO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionMMO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionSL(context, user) {
      const url = config.updateCommissionSLUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionSL.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionSL.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionSL.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionSL == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionSL",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionSL",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionSL.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionSL",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionLC(context, user) {
      const url = config.updateCommissionLCUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionLC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionLC.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionLC.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionLC == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionLC",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionLC",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionLC.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionLC",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionLO(context, user) {
      const url = config.updateCommissionLOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionLO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionLO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionLO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionLO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionLO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionLO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionKN(context, user) {
      const url = config.updateCommissionKNUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionKN.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionKN == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionKN",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionKN",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionKN.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionKN",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionCF(context, user) {
      const url = config.updateCommissionCFUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionCF.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionCF == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionCF",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionCF",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionCF.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionCF",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionLT(context, user) {
      const url = config.updateCommissionLTUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          one_d: user.one_d,
          two_d: user.two_d,
          three_d: user.three_d,
          four_d: user.four_d,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionLT.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionLT == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionLT",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionLT",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionLT.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionLT",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateCommissionTN(context, user) {
      const url = config.updateCommissionTNUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          account_commission: user.account_commission,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateCommissionTN.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateCommissionTN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateCommissionTN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateCommissionTN == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateCommissionTN",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateCommissionTN",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateCommissionCF.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateCommissionTN",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitSB(context, user) {
      const url = config.updateBetLimitSBUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bl: user.bl,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitSB.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitSB.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitSB.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitSB == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitSB",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitSB",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitSB.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitSB",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitLC(context, user) {
      const url = config.updateBetLimitLCUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitLC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitLC.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitLC.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitLC == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitLC",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitLC",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitLC.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitLC",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitLO(context, user) {
      const url = config.updateBetLimitLOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitLO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitLO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitLO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitLO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitLO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitLO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitKN(context, user) {
      const url = config.updateBetLimitKNUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitKN.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitKN == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitKN",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitKN",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitKN.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitKN",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitCF(context, user) {
      const url = config.updateBetLimitCFUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitCF.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitCF == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitCF",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitCF",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitCF.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitCF",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateBetLimitLT(context, user) {
      const url = config.updateBetLimitLTUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          bet_limit_packages: user.bet_limit_packages,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updateBetLimitLT.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag = errorTags.updateBetLimitLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag = errorTags.updateBetLimitLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateBetLimitLT == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateBetLimitLT",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateBetLimitLT",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updateBetLimitLT.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateBetLimitLT",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingSB1(context, user) {
      const url = config.updatePositionTakingSB1Url();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingSB1.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB1.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB1.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingSB1 == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingSB1",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB1",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag =
                      errorTags.updatePositionTakingSB1.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB1",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingSB2(context, user) {
      const url = config.updatePositionTakingSB2Url();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingSB2.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB2.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingSB2.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingSB2 == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingSB2",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB2",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag =
                      errorTags.updatePositionTakingSB2.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSB2",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingMMO(context, user) {
      const url = config.updatePositionTakingMMOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingMMO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingMMO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingMMO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingMMO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingMMO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingMMO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag =
                      errorTags.updatePositionTakingMMO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingMMO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingSL(context, user) {
      const url = config.updatePositionTakingSLUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingSL.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingSL.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingSL.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingSL == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingSL",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSL",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingSL.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingSL",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingLC(context, user) {
      const url = config.updatePositionTakingLCUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingLC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingLC.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingLC.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingLC == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingLC",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLC",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingLC.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLC",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingLO(context, user) {
      const url = config.updatePositionTakingLOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingLO.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingLO.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingLO == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingLO",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLO",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingLO.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLO",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingKN(context, user) {
      const url = config.updatePositionTakingKNUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingKN.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingKN.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingKN == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingKN",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingKN",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingKN.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingKN",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingCF(context, user) {
      const url = config.updatePositionTakingCFUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingCF.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingCF.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingCF == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingCF",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingCF",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingCF.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingCF",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePositionTakingLT(context, user) {
      const url = config.updatePositionTakingLTUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          pt: user.pt,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.updatePositionTakingLT.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.errorTag =
            errorTags.updatePositionTakingLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.errorTag =
            errorTags.updatePositionTakingLT.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePositionTakingLT == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updatePositionTakingLT",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLT",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.updatePositionTakingLT.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePositionTakingLT",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getForecastLookup(context, user) {
      const url = config.getForecastLookupUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_type: user.bet_type,
          league_name: user.league_name,
          page_number: user.page_number,
          page_size: user.page_size
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getForecastLookup.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getForecastLookup.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getForecastLookup.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getForecastLookup.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getForecastLookup.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getForecastLookup == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getForecastLookup",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getForecastLookup",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.forecastList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getForecastLookup.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getForecastLookup",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getForecastList(context, user) {
      const url = config.getForecastListUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_type: user.bet_type,
          match_id: user.match_id,
          submatch: user.submatch,
          max_ball: user.max_ball,
          max_ou: user.max_ou
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getForecastList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getForecastList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("match_id" in body.data)) {
          feedback.errorTag = errorTags.getForecastList.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("submatch" in body.data)) {
          feedback.errorTag = errorTags.getForecastList.subMatchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getForecastList.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getForecastList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.match_id.length <= 0) {
          feedback.errorTag = errorTags.getForecastList.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.submatch.length <= 0) {
          feedback.errorTag = errorTags.getForecastList.subMatchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getForecastList.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getForecastList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getForecastList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getForecastList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.forecastList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getForecastList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getForecastList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSettlementList(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type,
          status: user.status,
          show_all: user.show_all
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getSettlementList.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSettlementList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSettlementList.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSettlementList == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSettlementList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSettlementList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.settlementList;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSettlementList.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSettlementList",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    settlementAccount(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          settle_amount: user.settle_amount,
          remark: user.remark,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("settle_amount" in body.data)) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.settle_amount.length <= 0) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    settlementAgentBulk(context, user) {
      const url = config.settlementAgentBulkUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          list: user.list,
          parent_id: this.state.user.account.account_id,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("list" in body.data)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.list.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.Table1;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    settlementMemberBulk(context, user) {
      const url = config.settlementMemberBulkUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          list: user.list,
          parent_id: this.state.user.account.account_id,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("list" in body.data)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.list.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.Table1;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    settlementMemberBulkCash(context, user) {
      const url = config.settlementMemberBulkCashUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          list: user.list,
          parent_id: this.state.user.account.account_id,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("list" in body.data)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.list.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.Table1;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    transferCash(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          parent_id: this.state.user.account.account_id,
          settle_amount: user.settle_amount,
          method: user.method,
          remark: user.remark,
          audit_by: this.state.user.login.login_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.settlement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("settle_amount" in body.data)) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.settlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.settle_amount.length <= 0) {
          feedback.errorTag = errorTags.settlement.settleAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.settlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "settlement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.settlementList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.settlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "settlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSettlementHistory(context, user) {
      const url = config.getSettlementHistoryUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getSettlementHistory.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSettlementHistory.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSettlementHistory.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSettlementHistory == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSettlementHistory",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSettlementHistory",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.historyList;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSettlementHistory.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSettlementHistory",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailyStatement(context, user) {
      const url = config.getDailyStatementUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getDailyStatement.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getDailyStatement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailyStatement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailyStatement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailyStatement",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.dailyStatement;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailyStatement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailySettlement(context, user) {
      const url = config.getDailySettlementUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.account_id,
          working_date: user.working_date,
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getDailySettlement.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.getDailySettlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailySettlement.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailySettlement == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailySettlement",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailySettlement",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.dailySettlement;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailySettlement.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailySettlement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getDailyWinlose(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          target_id: user.target_id,
          search_id: user.search_id,
          platform: user.platform,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        line: [],
        success: false,
        errorTag: errorTags.getDailyWinlose.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getDailyWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getDailyWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getDailyWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getDailyWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getDailyWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.dailyWinlose;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    feedback.line = successResponse.body.data.line;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getDailyWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformWinlose(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPlatformWinlose.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getPlatformWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getPlatformWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPlatformWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getPlatformWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPlatformWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPlatformWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPlatformWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.platformWinlose;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPlatformWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPlatformWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSportTypeWinlose(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSportTypeWinlose.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSportTypeWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getSportTypeWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSportTypeWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getSportTypeWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSportTypeWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSportTypeWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSportTypeWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.sportTypeWinlose;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSportTypeWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSportTypeWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLeagueWinlose(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          sport_type: user.sport_type,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        names: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getLeagueWinlose.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getLeagueWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getLeagueWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("sport_type" in body.data)) {
          feedback.errorTag = errorTags.getLeagueWinlose.sportTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getLeagueWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getLeagueWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.sport_type.length <= 0) {
          feedback.errorTag = errorTags.getLeagueWinlose.sportTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getLeagueWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getLeagueWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getLeagueWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.leagueWinlose;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getLeagueWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getLeagueWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMatchWinlose(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          sport_type: user.sport_type,
          league_id: user.league_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type,
        }
      };
      const feedback = {
        data: [],
        names: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getMatchWinlose.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getMatchWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getMatchWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("sport_type" in body.data)) {
          feedback.errorTag = errorTags.getMatchWinlose.sportTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("league_id" in body.data)) {
          feedback.errorTag = errorTags.getMatchWinlose.leagueIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.sport_type.length <= 0) {
          feedback.errorTag = errorTags.getMatchWinlose.sportTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.league_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchWinlose.leagueIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMatchWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getMatchWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMatchWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.matchWinlose;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getMatchWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMatchWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMatchMemberWinlose(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          sport_type: user.sport_type,
          league_id: user.league_id,
          match_id: user.match_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getMatchMemberWinlose.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("sport_type" in body.data)) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.sportTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("league_id" in body.data)) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.leagueIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("match_id" in body.data)) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.sport_type.length <= 0) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.sportTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.league_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.leagueIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.match_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchMemberWinlose.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMatchMemberWinlose == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getMatchMemberWinlose",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMatchMemberWinlose",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.matchMemberWinlose;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getMatchMemberWinlose.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMatchMemberWinlose",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCancelledBetlist(context, user) {
      const url = config.getCancelledBetlistUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          start_date: user.start_date,
          end_date: user.end_date,
          search_by_working_date: user.search_by_working_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTournamentRefundList(context, user) {
      const url = config.getTournamentRefundListUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          start_date: user.start_date,
          end_date: user.end_date,
          search_by_working_date: user.search_by_working_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getTournamentRefund.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getTournamentRefund.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getTournamentRefund.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getTournamentRefund == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getTournamentRefund", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getTournamentRefund",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.refundlist;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getTournamentRefund.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getTournamentRefund",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSystemParlay(context, user) {
      const url = config.getSystemParlayUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getSystemParlay.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSystemParlay == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSystemParlay",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSystemParlay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.systemParlay;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSystemParlay.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetSystemParlay(context, user) {
      const url = config.getBetSystemParlayUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSystemParlay.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSystemParlay == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSystemParlay",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSystemParlay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.systemParlayBet;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSystemParlay.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetSystemParlayMatch(context, user) {
      const url = config.getBetSystemParlayMatchUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          system_parlay_id: user.system_parlay_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSystemParlay.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSystemParlayMatch == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSystemParlay",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSystemParlay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.systemParlayMatch;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSystemParlay.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetSystemParlayBet(context, user) {
      const url = config.getBetSystemParlayBetUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          system_parlay_id: user.system_parlay_id,
          page_number: user.page_number,
          page_size: user.page_size
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getSystemParlay.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getSystemParlay.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getSystemParlayBet == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSystemParlay",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSystemParlay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.systemParlayBet;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSystemParlay.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getDailyStatement",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getStock(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getStockOutstanding(context, user) {
      const url = config.getStockOutstandingUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        line: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.line = successResponse.body.data.line;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getStockOutstandingLottery(context, user) {
      const url = config.getStockOutstandingLotteryUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        line: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("search_id" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.search_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.searchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.line = successResponse.body.data.line;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistHDP(context, user) {
      const url = config.getActiveBetlistHDPUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_type: user.bet_type,
          match_id: user.match_id,
          is_live: user.is_live,
          home_running_score: user.home_running_score,
          away_running_score: user.away_running_score
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("match_id" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("is_live" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.isLiveRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("home_running_score" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.homeRunningScoreRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("away_running_score" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.awayRunningScoreRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.match_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.is_live.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.isLiveRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.home_running_score.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.homeRunningScoreRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.away_running_score.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.awayRunningScoreRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistOE(context, user) {
      const url = config.getActiveBetlistOEUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_type: user.bet_type,
          match_id: user.match_id,
          home_away: user.home_away
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("match_id" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("home_away" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.homeAwayRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.match_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.home_away.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.homeAwayRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistBetType(context, user) {
      const url = config.getActiveBetlistBetTypeUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_type: user.bet_type,
          member_id: user.member_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistAll(context, user) {
      const url = config.getActiveBetlistAllUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          member_id: user.member_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistDetail(context, user) {
      const url = config.getActiveBetlistDetailUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_type: user.bet_type,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistMatch(context, user) {
      const url = config.getActiveBetlistMatchUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          match_id: user.match_id,
          bet_type: user.bet_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("bet_type" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("match_id" in body.data)) {
          feedback.errorTag = errorTags.getBetlist.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.bet_type.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.betTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.match_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.matchIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistLottery(context, user) {
      const url = config.getActiveBetlistLotteryUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          member_id: user.member_id,
          num_type: user.num_type,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getActiveBetlistESports2(context, user) {
      const url = config.getActiveBetlistESports2Url();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          member_id: user.member_id,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getBetlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getBetlist.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBetlist == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBetlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.betList;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getBetlist.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getBetlist",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPendingMatches(context) {
      const url = config.getPendingMatchesUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getPendingMatches.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getPendingMatches.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getPendingMatches.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPendingMatches == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPendingMatches",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPendingMatches",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.pendingMatches;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getPendingMatches.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPendingMatches",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getGameResult(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          member_id: user.member_id,
          start_date: user.start_date,
          end_date: user.end_date,
          search_by_working_date: user.search_by_working_date,
          sport_type: user.sport_type,
          league_id: user.league_id,
          match_id: user.match_id,
          game_name: user.game_name,
          game_provider: user.game_provider,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        names: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getGameResult.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("member_id" in body.data)) {
          feedback.errorTag = errorTags.getGameResult.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getGameResult.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.member_id.length <= 0) {
          feedback.errorTag = errorTags.getGameResult.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getGameResult == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getGameResult",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.gameResult;
                    feedback.names = successResponse.body.names;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getGameResult.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getGameResult",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getGameResultDetail(context, user) {
      const url = user.url;
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          member_id: user.member_id,
          start_date: user.start_date,
          end_date: user.end_date,
          search_by_working_date: user.search_by_working_date,
          sport_type: user.sport_type,
          league_id: user.league_id,
          match_id: user.match_id,
          game_name: user.game_name,
          game_provider: user.game_provider,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        names: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getGameResult.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("member_id" in body.data)) {
          feedback.errorTag = errorTags.getGameResult.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getGameResult.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.member_id.length <= 0) {
          feedback.errorTag = errorTags.getGameResult.memberIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getGameResult == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getGameResult",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.gameResult;
                    feedback.names = successResponse.body.names;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getGameResult.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getGameResult",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getParlayDetail(context, user) {
      const url = config.getParlayDetailUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_id: user.bet_id
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getParlayDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("bet_id" in body.data)) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.bet_id.length <= 0) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getParlayDetail == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getParlayDetail",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.parlayDetail;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getParlayDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getParlayDetailMMO(context, user) {
      const url = config.getParlayDetailMMOUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_id: user.bet_id
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getParlayDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("bet_id" in body.data)) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.bet_id.length <= 0) {
          feedback.errorTag = errorTags.getParlayDetail.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getParlayDetail == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getParlayDetail",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.parlayDetail;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getParlayDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getParlayDetail",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getEsportsDetailCombo(context, user) {
      const url = config.getGameResultEsportsDetailComboUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_id: user.bet_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getEsportsDetailCombo.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("bet_id" in body.data)) {
          feedback.errorTag = errorTags.getEsportsDetailCombo.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.bet_id.length <= 0) {
          feedback.errorTag = errorTags.getEsportsDetailCombo.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getEsportsDetailCombo == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getEsportsDetailCombo",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getEsportsDetailCombo",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.gameResult;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getEsportsDetailCombo.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getEsportsDetailCombo",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetListEsportsDetailCombo(context, user) {
      const url = config.getBetListEsportsDetailComboUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          bet_id: user.bet_id
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getEsportsDetailCombo.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("bet_id" in body.data)) {
          feedback.errorTag = errorTags.getEsportsDetailCombo.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.bet_id.length <= 0) {
          feedback.errorTag = errorTags.getEsportsDetailCombo.betIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getEsportsDetailCombo == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", {
            action: "getEsportsDetailCombo",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getEsportsDetailCombo",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.gameResult;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getEsportsDetailCombo.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getEsportsDetailCombo",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getGameTypeLookup(context, user) {
      const url = config.getGameTypeLookupUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getGameTypeLookup.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        // if (this.state.user._loading.getGameTypeLookup == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          // context.commit("loading", {
          //   action: "getGameTypeLookup",
          //   status: true
          // });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", {
              //   action: "getGameTypeLookup",
              //   status: false
              // });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;
                  try {
                    data = successResponse.body.data.detail;
                    feedback.data = data;
                    context.commit("updateGameTypeLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getGameTypeLookup.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", {
              //   action: "getGameTypeLookup",
              //   status: false
              // });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLeagueLookup(context, user) {
      const url = config.getLeagueLookupUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          working_date: user.working_date,
          game_type: user.game_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getLeagueLookup.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("working_date" in body.data)) {
          feedback.errorTag = errorTags.getLeagueLookup.dateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("game_type" in body.data)) {
          feedback.errorTag = errorTags.getLeagueLookup.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.working_date.length <= 0) {
          feedback.errorTag = errorTags.getLeagueLookup.dateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.game_type.length <= 0) {
          feedback.errorTag = errorTags.getLeagueLookup.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.getLeagueLookup == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          // context.commit("loading", {
          //   action: "getLeagueLookup",
          //   status: true
          // });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", {
              //   action: "getLeagueLookup",
              //   status: false
              // });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.data.detail;
                    feedback.data = data;
                    context.commit("updateLeagueLookUp", { data });
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getLeagueLookup.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", {
              //   action: "getLeagueLookup",
              //   status: false
              // });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMatchResult(context, user) {
      const url = config.getMatchResultUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          working_date: user.working_date,
          game_type: user.game_type,
          league_id: user.league_id
        }
      };
      const feedback = {
        data: [],
        names: [],
        success: false,
        errorTag: errorTags.getMatchResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("working_date" in body.data)) {
          feedback.errorTag = errorTags.getMatchResult.dateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("game_type" in body.data)) {
          feedback.errorTag = errorTags.getMatchResult.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("league_id" in body.data)) {
          feedback.errorTag = errorTags.getMatchResult.leagueIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.working_date.length <= 0) {
          feedback.errorTag = errorTags.getMatchResult.dateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.game_type.length <= 0) {
          feedback.errorTag = errorTags.getMatchResult.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (body.data.league_id.length <= 0) {
          feedback.errorTag = errorTags.getMatchResult.leagueIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getMatchResult == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getMatchResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMatchResult",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.detail;
                    feedback.names = successResponse.body.names;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getMatchResult.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMatchResult",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkDownline(context, id) {
      const url = config.checkDownlineUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.checkDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.checkDownline == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "checkDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                resolve(feedback);
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkAccountReserved(context, id) {
      const url = config.checkAccountReservedUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.checkDownline.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.checkDownline == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          context.commit("loading", { action: "checkDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                resolve(feedback);
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    checkDownlineExist(context, id) {
      const url = config.checkDownlineExistUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: id
        }
      };
      const feedback = {
        success: false,
        errorTag: errorTags.checkDownline.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.checkDownline.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.checkDownline == true) {
        //   feedback.errorTag = errorTags.request.processing;
        //   canRequest = false;
        // }
        if (canRequest == true) {
          context.commit("loading", { action: "checkDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                resolve(feedback);
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "checkDownline",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCreditUsedSummary(context) {
      const url = config.getCreditUsedSummaryUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getCreditUsedSummary.failed
      };
  
      return new Promise((resolve, reject) => {
        var canRequest = true;
  
        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getCreditUsedSummary.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
  
        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getCreditUsedSummary.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }
  
        if (this.state.user._loading.getCreditUsedSummary == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
  
        if (canRequest == true) {
          context.commit("loading", { action: "getCreditUsedSummary", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCreditUsedSummary",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  var data = null;
  
                  try {
                    data = successResponse.body.data.data;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getCreditUsedSummary.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCreditUsedSummary",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTournamentJackpot(context, user) {
      const url = config.getTournamentJackpotUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          account_id: user.search_id,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        grandTotal: [],
        success: false,
        errorTag: errorTags.getTournamentJackpot.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.data)) {
          feedback.errorTag = errorTags.getTournamentJackpot.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.data.account_id.length <= 0) {
          feedback.errorTag = errorTags.getTournamentJackpot.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getTournamentJackpot == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getTournamentJackpot",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getTournamentJackpot",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.jackpotlist;
                    feedback.grandTotal = successResponse.body.data.grandtotal;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getSettlementHistory.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getTournamentJackpot",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
